import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import type { Tenant } from "~api/tenants";
import { useAllTenants } from "~api/tenants";
import { useAuth } from "~auth/useAuth";
import { useCurrentEmployee } from "~contexts/CurrentEmployeeContext/CurrentEmployeeContext";

export function useSetPostHogProperties() {
  const { data: tenants } = useAllTenants();
  const { currentEmployee } = useCurrentEmployee();
  const { activeAccount } = useAuth();
  const postHog = usePostHog();

  useEffect(() => {
    if (currentEmployee && tenants) {
      const tenant = tenants.find((t) => t.id === currentEmployee.tenant_id);

      postHog.setPersonProperties({
        jobTitle: currentEmployee.job_title,
        staffNumber: currentEmployee.staff_number,
        tenant: toPostHogTenant(tenant),
        email: activeAccount?.username,
      });
    }
  }, [currentEmployee, postHog, tenants, activeAccount?.username]);
}

export function toPostHogTenant(tenant?: Tenant) {
  if (!tenant) {
    return undefined;
  }
  return tenant.shortName;
}
